import { createAPIActions } from '../../utils';

export const AUTH_INITIAL_STATE = {
  isFetching: false,
};
export const LOG_IN_API = createAPIActions('do', 'log_in/api');
